import { useState } from 'react';

import { Tabs } from '../components/DesignSystem';
import { PageHeader } from '../components/PageHeader';
import { AvailabilityTab } from './rights/AvailabilityTab';
import { ManageRightsTab } from './rights/ManageRightsTab';
import { MatrixTab } from './rights/MatrixTab';
import { RightsDashboardTab } from './rights/RightsDashboardTab';

type TabKey =
  | 'dashboard'
  | 'manage'
  | 'matrix'
  | 'availability'
  | 'ai'
  | 'conflicts'
  | 'deliveries';

const COMING_SOON_TABS: ReadonlySet<string> = new Set(['ai', 'conflicts', 'deliveries']);

const TAB_ITEMS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'manage', label: 'Manage Rights' },
  { key: 'matrix', label: 'Matrix View' },
  { key: 'availability', label: 'Availability Search' },
  { key: 'ai', label: 'AI Search' },
  { key: 'conflicts', label: 'Conflicts' },
  { key: 'deliveries', label: 'Deliveries' },
];

/** `/rights` — rights tracker with dashboard, manage, matrix, availability. */
export function RightsPage() {
  const [tab, setTab] = useState<TabKey>('dashboard');

  return (
    <>
      <PageHeader
        caption="Manage primary rights, secondary rights, holdbacks, premieres, license periods, and clearance — linked to your contracts."
        title="Rights Management"
      />

      <div className="rfp-toolbar" title="AI Search, Conflicts and Deliveries are coming soon">
        <Tabs
          active={tab}
          items={TAB_ITEMS.map((item) => ({ ...item, disabled: COMING_SOON_TABS.has(item.key) }))}
          onChange={(key) => {
            // Placeholder tabs render but stay inert until those modules ship.
            if (!COMING_SOON_TABS.has(key)) {
              setTab(key as TabKey);
            }
          }}
        />
      </div>

      {tab === 'dashboard' && <RightsDashboardTab />}
      {tab === 'manage' && <ManageRightsTab />}
      {tab === 'matrix' && <MatrixTab />}
      {tab === 'availability' && <AvailabilityTab />}
    </>
  );
}
